import { memo } from 'react';

import { FileStatusIconProgressing, FileStatusSubtitle, FileStatusTitle } from '@air/feature-file-status/ui';

import { EllipsisInMiddle } from '~/components/EllipsisInMiddle';
import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneCancelOrHideButton } from '~/components/FileStatusTrackingPane/TaskPaneCancelOrHideButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';
import { type BoardRestorationTask, type GetInProgressMetadata } from '~/store/tasks/types';

export type RestoreBoardPanelInProgressPanelItemProps = {
  metadata: Pick<GetInProgressMetadata<BoardRestorationTask>, 'title'>;
  onCancel: () => void;
};

export const RestoreBoardPanelInProgressPanelItem = memo(
  ({ onCancel, metadata: { title } }: RestoreBoardPanelInProgressPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();

    return (
      <PaneItemTW
        avatar={<FileStatusIconProgressing size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={<FileStatusTitle>{ui2026 ? 'Recovering…' : 'Recovering'}</FileStatusTitle>}
        subtitle={
          <FileStatusSubtitle className="flex text-nowrap">
            <span className="flex-none pr-1">Recovering board: </span>
            <EllipsisInMiddle className="font-bold" text={title || ''} />
          </FileStatusSubtitle>
        }
        buttons={<TaskPaneCancelOrHideButton onClick={onCancel} />}
      />
    );
  },
);

RestoreBoardPanelInProgressPanelItem.displayName = 'RestoreBoardPanelInProgressPanelItem';
